/**
 * Cart Offers Visibility Manager
 * Updates the data-cart-empty attribute on the offers container
 * This ensures offers are shown/hidden correctly based on cart state
 * 
 * Version: 1.0.0
 */

(function() {
  'use strict';

  console.log('[OffersVisibility] 🎯 Initializing...');

  /**
   * Update offers container visibility based on cart state
   */
  function updateOffersVisibility(cart) {
    const offersContainer = document.querySelector('.mini-cart__offers-container');
    
    if (!offersContainer) {
      console.log('[OffersVisibility] ⚠️ Offers container not found');
      return;
    }

    const isEmpty = !cart || cart.item_count === 0;
    offersContainer.setAttribute('data-cart-empty', isEmpty);
    
    console.log('[OffersVisibility] 📊 Cart state:', {
      itemCount: cart ? cart.item_count : 0,
      isEmpty: isEmpty,
      containerVisible: !isEmpty
    });
  }

  /**
   * Initialize on page load
   */
  async function initialize() {
    try {
      // Get initial cart state
      const response = await fetch('/cart.js');
      const cart = await response.json();
      updateOffersVisibility(cart);
      
      console.log('[OffersVisibility] ✅ Initialized');
    } catch (error) {
      console.error('[OffersVisibility] ❌ Initialization error:', error);
    }
  }

  /**
   * Listen to cart updates
   */
  function attachEventListeners() {
    // Listen to cart:updated event
    document.documentElement.addEventListener('cart:updated', (event) => {
      console.log('[OffersVisibility] 🔔 Cart updated');
      const cart = event.detail?.cart;
      if (cart) {
        updateOffersVisibility(cart);
      }
    });

    // Listen to cart:refresh event
    document.documentElement.addEventListener('cart:refresh', (event) => {
      console.log('[OffersVisibility] 🔄 Cart refresh');
      const cart = event.detail?.cart;
      if (cart) {
        updateOffersVisibility(cart);
      }
    });

    console.log('[OffersVisibility] ✓ Event listeners attached');
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      attachEventListeners();
      initialize();
    });
  } else {
    attachEventListeners();
    initialize();
  }

})();
